module.exports = __webpack_public_path__ + "img/wz-5-1.ba7798bb.png";